<template>
  <div>
    <v-list class="conversation">
      <v-list-item>
        <v-list-item-avatar size="50">
          <v-badge
            bordered
            bottom
            :color="users.Online ? 'green' : 'red'"
            dot
            offset-x="10"
            offset-y="10"
          >
            <v-avatar size="40">
              <v-img v-if="users.Image != null" :src="users.Image"></v-img>
              <v-img v-else src="../../assets/default.png"></v-img>
            </v-avatar>
          </v-badge>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="users.Name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
/*eslint-disable */
export default {
  props: {
    users: {
      type: Object,
      default: () => {},
    },
    userId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.conversation {
  cursor: pointer;
  padding: 0;
}

.conversation:hover {
  background-color: rgb(245, 243, 243);
}
</style>
